// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"2b157d6a","465":"136282a4","580":"b9ac3397","625":"a923f5ef","631":"aca695a3"}[chunkId] + ".chunk.css";
};